import { useDragAndDropContext } from "./DragAndDropContext";
import { useSelectedDateHasPassed } from "@/Utils/useSelectedDate";
import { routeStatusSchema, type IRouteStatus } from "@medoma/models/routes";

export const useIsRouteDropZoneAvailable = ({
  routeStatus,
  routeId,
}: {
  routeStatus: IRouteStatus;
  routeId: string;
}) => {
  const { availableDropZones, drag } = useDragAndDropContext();
  const selectedDateHasPassed = useSelectedDateHasPassed();

  // If the base availability is false, no need to check additional conditions
  if (!availableDropZones.route) {
    return false;
  }

  // If the selected date has passed, the route dropzone is not available
  if (selectedDateHasPassed) {
    return false;
  }

  // If the route is finished, the route dropzone is not available
  if (routeStatus === routeStatusSchema.enum.finished) {
    return false;
  }

  // If the drag source route id is the same as the route id, the route dropzone is not available
  if (drag?.source === "route" && drag.routeId === routeId) {
    return false;
  }

  return true;
};
